// eslint-disable-next-line
export const SET_DATA_MODELS = 'datamodels/set-data-models';
